// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import * as Sentry from '@sentry/nextjs';
import posthog from 'posthog-js';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { sentryConfig } from './sentry.config';

Sentry.init({
  // @ts-ignore - Sentry integration type conflicts due to multiple package versions
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    posthog.sentryIntegration({
      organization: 'luminary', // sentry organization
      projectId: 4503959315283968, // sentry project id (interface)
      severityAllowList: ['error', 'info'],
    }),
  ],
  ...sentryConfig,
});

// Required for Sentry to instrument Next.js navigations
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
